import SectionLoader from "@/components/Loader/SectionLoader";
import NoData from "@/components/ui/NoData";

export const gmbLabelsDialogsLogic = {
  components: {
    SectionLoader,
    NoData
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    initiallySelectedLabels: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      labels: [],
      labelSearchInputValue: "",
      loadingList: false,
      listItemHeight: 50
    };
  },

  computed: {
    filteredLabels() {
      return this.labels.filter(label =>
        label.value
          .toLowerCase()
          .includes(this.labelSearchInputValue.toLowerCase())
      );
    },
    selectedLabels() {
      return this.labels.filter(label => label.isSelected);
    },
    listHeight() {
      return this.listItemHeight * 8;
    }
  },

  methods: {
    toggleLabel(label) {
      const labelIndex = this.labels.findIndex(l => l.id === label.id);

      if (labelIndex >= 0) {
        this.labels[labelIndex].isSelected = !this.labels[labelIndex]
          .isSelected;
      }
    },

    setInitialLabels() {
      this.initiallySelectedLabels.forEach(label => {
        const labelIndex = this.labels.findIndex(l => l.value === label);

        if (labelIndex >= 0) {
          this.labels[labelIndex].isSelected = true;
        }
      });
    },

    close() {
      this.$emit("close");
    }
  }
};
